// Module
var code = "<div id=\"content\" class=\"analysis-list-item\">\n    <div class=\"title-bar\">\n        <h4 id=\"name\">{{ name }}</h4>\n        <button id=\"remove\" type=\"button\">Ｘ</button>\n    </div>\n    <div id=\"visualisers\">\n        \n    </div>\n    <button id=\"add\" type=\"button\">＋</button>\n</div>";
// Exports
module.exports = code;